import { useCopy } from '../hooks/useCopy';
import { Button } from './Button';
import { useToast } from './Toast';
import { CheckIcon, CopyIcon } from './icons';

/**
 * Bouton de copie avec retour « Copié » (1,5 s) annoncé via aria-live : composant Button
 * (ghost, sm ; icône seule quand le libellé n'est pas affiché).
 * @param {() => string} getText  Texte à copier, calculé au clic
 * @param {Function} icon  Icône au repos (copie par défaut, lien pour une ancre)
 */
export function CopyButton({ getText, label = 'Copier', showLabel = false, className = '', size = 15, icon: Icon = CopyIcon }) {
  const { copied, copy } = useCopy();
  const toast = useToast();

  const handleClick = async (event) => {
    event.stopPropagation();
    const ok = await copy(getText());
    if (!ok) toast('Copie impossible', { tone: 'error' });
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      icon={copied ? CheckIcon : Icon}
      iconSize={size}
      iconOnly={!showLabel}
      className={`copy-button ${copied ? 'is-copied' : ''} ${className}`.trim()}
      onClick={handleClick}
      aria-label={showLabel ? undefined : label}
      title={label}
    >
      {showLabel && <span>{copied ? 'Copié' : 'Copier'}</span>}
      <span className="sr-only" aria-live="polite">{copied ? 'Copié' : ''}</span>
    </Button>
  );
}
